import { createFileRoute } from "@tanstack/react-router";
import { WorkspaceMembersPage } from "@/features/workspaces/workspace-members.page";

export const Route = createFileRoute("/_authenticated/workspaces/$slug/members")({
  component: WorkspaceMembersPage,
});
